module.exports = __webpack_public_path__ + "img/ryzs1.c53fea1c.jpg";